import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
  NzTableModule,
  NzTheadComponent,
  NzTbodyComponent,
  NzTrDirective,
  NzTrMeasureComponent,
  NzThMeasureDirective,
  NzThAddOnComponent,
} from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-view-table',
  templateUrl: './view-table.component.html',
  styleUrl: './view-table.component.scss',
})
export class ViewTableComponent implements AfterViewInit, OnDestroy {
  @Input() columns: // {
  //   title: string;
  //   key: string;
  //   width?: string;
  //   sortOrder?: NzTableSortOrder;
  //   sortFn?: (a: any, b: any) => number | null;
  //   filters?: { text: string; value: any }[];
  //   filterFn?: (value: any, data: any[]) => boolean;
  //   searchable?: boolean; // Add this line
  //   distinctable?: boolean;
  //   visible: boolean;
  // }
  any[] = [];

  @Output() columnSearchChange = new EventEmitter<{
    key: string;
    searchValue: string;
  }>();
  @Input() nzScroll: {
    x?: string | null;
    y?: string | null;
  };
  @Input() data: any[] = [];
  @Input() bordered: boolean = false;
  @Input() loading: boolean = false;
  @Input() pagination: boolean = true;
  @Input() pageSize: number = 10;
  @Input() currentPage: number = 1;
  @Input() total: number = 0;
  @Input() scroll: { x?: string; y?: string } | null = null;
  @Input() actions: {
    key: string;
    label: string;
    type?: 'link' | 'primary' | 'default' | 'dashed' | 'text';
    icon?: string;
    danger?: boolean;
  }[] = [];
  @Input() searchMode: 'frontend' | 'api' = 'api';
  @Input() quickSearch: boolean = false;
  @Input() quickSearchPlaceholder: string = 'Search...';

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() rowClick = new EventEmitter<any>();
  @Output() columnSortChange = new EventEmitter<
    {
      columnName: string;
      value: 'ascend' | 'descend';
    }[]
  >();
  @Output() columnFilterChange = new EventEmitter<{
    key: string;
    filters: any[];
  }>();
  @Output() actionClick = new EventEmitter<{ actionKey: string; row: any }>();

  @ViewChildren(NzDropdownMenuComponent)
  dropdownMenus!: QueryList<NzDropdownMenuComponent>;
  @ViewChildren('headerRef', { read: ElementRef }) headerCells!: QueryList<ElementRef>;
  @ViewChildren('tdRef', { read: ElementRef }) rowCell!: QueryList<ElementRef>;

  @Input() pageSizeOptions: number[] = [20, 50, 100, 500, 1000];

  public sortValues: { columnName: string; value: 'ascend' | 'descend' }[] = [];

  // properties of handling custom search

  public viewInited: boolean = false;
  public activeColumnKey: string | null = null;
  public searchValues: { [key: string]: string } = {};
  public searchVisible: { [key: string]: boolean } = {};
  public menuMap: { [key: string]: NzDropdownMenuComponent } = {};
  public filteredData: any[] = [];
  public frontendTotal: number = 0;

  public activeDistinctColumnKey: string | null = null;

  @Output() columnDistinctChange = new EventEmitter<{
    key: string;
    distinct: boolean;
  }>();

  public quickSearchValue: string = '';
  private quickSearchInput$ = new Subject<string>();

  constructor() {
    this.quickSearchInput$.pipe(debounceTime(200)).subscribe((value) => {
      this.quickSearchValue = value;
      this.applyFrontendFilter();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.quickSearchInput$.complete();
  }

  onQuickSearchInput(value: string): void {
    this.quickSearchInput$.next(value);
  }

  clearQuickSearch(): void {
    this.quickSearchValue = '';
    this.quickSearchInput$.next('');
  }

  syncColumnVisibility(): void {
    this.visibleColumns = this.columns.filter((col) => col.visible);
    this.hiddenColumns = this.columns.filter((col) => !col.visible);
  }

  columnWidths: string[] = [];

  ngAfterViewInit() {
    const searchableColumns = this.columns.filter((c) => c.searchable);
    this.dropdownMenus.forEach((menu, index) => {
      const columnKey = searchableColumns[index]?.key;
      if (columnKey) {
        this.menuMap[columnKey] = menu;
      }
    });
    this.viewInited = true;
    //setTimeout(()=>this.calculateHeaderWidthsResize(),5000);
  }

  calculateHeaderWidths() {
    const head = document.getElementsByTagName('col');
    //console.log("salam",head);
    for (let i = 0; i < head.length; i++) {
      head[i].style.removeProperty('width');
      head[i].style.removeProperty('min-width');
    }

    this.headerCells.forEach((item) => {
      //console.log("salam : " , item.nativeElement.offsetWidth)
      item.nativeElement.style.removeProperty('width');
      if (this.pageSize > 101) {
        let maxRow = 100;
        if (this.rowCell.length < 100) {
          maxRow = this.rowCell.length;
        }
        for (let i = 0; i < maxRow; i++) {
          if (
            this.rowCell.get(i)?.nativeElement.children[item.nativeElement.cellIndex].offsetWidth >
            item.nativeElement.offsetWidth
          ) {
            item.nativeElement.style.width = `${this.rowCell.get(i)?.nativeElement.children[item.nativeElement.cellIndex].offsetWidth}px`;
          } else {
            this.rowCell.first.nativeElement.children[item.nativeElement.cellIndex].style.width =
              `${item.nativeElement.offsetWidth}px`;
          }
        }
      } else {
        this.rowCell.forEach((rItem) => {
          //console.log("salam 2: " ,rItem.nativeElement.children[item.nativeElement.cellIndex].offsetWidth);
          const cell = rItem.nativeElement.children[item.nativeElement.cellIndex];
          cell.style.removeProperty('width');
          if (
            rItem.nativeElement.children[item.nativeElement.cellIndex].offsetWidth >
            item.nativeElement.offsetWidth
          ) {
            item.nativeElement.style.width = `${rItem.nativeElement.children[item.nativeElement.cellIndex].offsetWidth}px`;
          } else {
            rItem.nativeElement.children[item.nativeElement.cellIndex].style.width =
              `${item.nativeElement.offsetWidth}px`;
          }
        });
      }
    });
  }

  calculateHeaderWidthsResize() {
    // this.headerCells.forEach(item => {
    //     console.log("salam r : " , item.nativeElement.offsetWidth)
    //     item.nativeElement.style.width = '';
    //     this.rowCell.forEach(rItem => {
    //           rItem.nativeElement.children[item.nativeElement.cellIndex].style.width = '';
    //           console.log("salam r : " , rItem.nativeElement.children[item.nativeElement.cellIndex].offsetWidth)
    //     });
    // });
    this.calculateHeaderWidths();
  }

  trackColumn(index: number, column: any) {
    return column.key;
  }

  /**
   * Rows come from arbitrary dynamic tables with no guaranteed unique key, so the index is the
   * only stable identity available. Paired with the template binding to `data`/`filteredData`
   * directly (instead of a method call returning a fresh array), this lets Angular reuse the
   * row DOM instead of rebuilding every cell on each change-detection pass.
   */
  trackRow(index: number, row: any) {
    return index;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.searchMode === 'frontend') {
      this.applyFrontendFilter();
    }
    if (changes['columns']) {
      this.columns = this.columns.map((col) => ({
        ...col,
        visible: true,
      }));
      this.syncColumnVisibility();
    }
    setTimeout(() => this.calculateHeaderWidths(), 500);
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  onPageSizeChange(pageSize: number): void {
    console.log('here');
    this.pageSizeChange.emit(pageSize);
  }

  onRowClick(row: any): void {
    this.rowClick.emit(row);
  }

  onSortChange(sortOrder: string | null | any, columnKey: string): void {
    const index = this.sortValues.findIndex((s) => s.columnName == columnKey);
    if (sortOrder == null) this.sortValues.splice(index, 1);
    else if (index == -1) this.sortValues.push({ columnName: columnKey, value: sortOrder });
    else this.sortValues[index].value = sortOrder;
    this.columnSortChange.emit(this.sortValues);
  }

  onFilterChange(filters: any[], columnKey: string): void {
    this.columnFilterChange.emit({ key: columnKey, filters });
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    this.columns = this.columns.map((e) => (e.key === col ? { ...e, width: `${width}px` } : e));
  }

  onActionClick(actionKey: string, row: any): void {
    this.actionClick.emit({ actionKey, row });
  }

  onSearchVisibleChange(columnKey: string, visible: boolean): void {
    if (visible) {
      this.columns.forEach((col) => {
        if (col.key !== columnKey) {
          this.searchVisible[col.key] = false;
        }
      });
      this.activeColumnKey = columnKey;
    } else {
      this.activeColumnKey = null;
    }
    this.searchVisible[columnKey] = visible;
  }

  applySearch(columnKey: string): void {
    this.searchVisible[columnKey] = false;

    if (this.searchMode === 'frontend') {
      this.applyFrontendFilter();
    } else {
      this.columnSearchChange.emit({
        key: columnKey,
        searchValue: this.searchValues[columnKey] || '',
      });
    }
  }

  resetSearch(columnKey: string): void {
    this.searchValues[columnKey] = '';

    if (this.searchMode === 'frontend') {
      this.applyFrontendFilter();
    } else {
      this.columnSearchChange.emit({
        key: columnKey,
        searchValue: '',
      });
    }
    this.searchVisible[columnKey] = false;
  }

  private applyFrontendFilter(): void {
    const searchableColumns = this.columns.filter((column) => column.searchable);
    const quickSearchValue = this.quickSearchValue.trim().toLowerCase();

    this.filteredData = this.data.filter((row) => {
      const matchesColumnFilters = this.columns.every((column) => {
        if (!column.searchable || !this.searchValues[column.key]) return true;
        const cellValue = String(row[column.key] || '').toLowerCase();
        const searchValue = this.searchValues[column.key].toLowerCase();
        return cellValue.includes(searchValue);
      });
      if (!matchesColumnFilters) return false;

      if (!quickSearchValue) return true;
      return searchableColumns.some((column) =>
        String(row[column.key] || '')
          .toLowerCase()
          .includes(quickSearchValue),
      );
    });
    this.frontendTotal = this.filteredData.length;
  }

  selectDataToLoad() {
    return this.searchMode === 'frontend' ? this.filteredData : this.data;
  }

  toggleDistinct(columnKey: string): void {
    const prevKey = this.activeDistinctColumnKey;
    this.activeDistinctColumnKey = this.activeDistinctColumnKey === columnKey ? null : columnKey;

    if (this.searchMode === 'frontend') {
      this.applyFrontendFilter();
    } else {
      this.columnDistinctChange.emit({
        key: columnKey,
        distinct: this.activeDistinctColumnKey === columnKey,
      });
    }

    // Reset pagination if needed
    if (prevKey !== this.activeDistinctColumnKey) {
      this.currentPage = 1;
    }
  }

  // Boolean to control modal visibility
  public isSettingsModalVisible = false;

  // Two arrays to track visible and hidden columns
  public visibleColumns: any[] = []; // Will be a subset of this.columns
  public hiddenColumns: any[] = [];

  showSettingsModal(): void {
    this.isSettingsModalVisible = true;
  }

  handleSettingsCancel(): void {
    this.isSettingsModalVisible = false;
    // Optionally, reset the temporary settings if needed.
  }

  handleSettingsOk(): void {
    // Merge visible and hidden settings back into the main columns array
    // Here you might also want to preserve order from visibleColumns first.
    this.columns = [...this.visibleColumns, ...this.hiddenColumns];

    // اطمینان از بروزرسانی visible برای همه ستون‌ها
    this.columns.forEach((col) => {
      col.visible = this.visibleColumns.some((visCol) => visCol.key === col.key);
    });

    this.isSettingsModalVisible = false;
  }

  hideColumn(col: any, index: number): void {
    // Mark column as hidden and move it from visibleColumns to hiddenColumns
    col.visible = false;
    this.visibleColumns.splice(index, 1);
    this.hiddenColumns.push(col);
  }

  showColumn(col: any, index: number): void {
    // Mark column as visible and move it from hiddenColumns to visibleColumns
    col.visible = true;
    this.hiddenColumns.splice(index, 1);
    this.visibleColumns.push(col);
  }

  drop(event: CdkDragDrop<any[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );

      // Update visible property for the moved item
      const movedItem = event.container.data[event.currentIndex];

      // Update visibility based on which container we moved to
      if (event.container.id === 'visibleList') {
        movedItem.visible = true;
      } else if (event.container.id === 'hiddenList') {
        movedItem.visible = false;
      }
    }
  }

  returnFilteredColumns() {
    return this.columns.filter((c) => c.visible);
  }
}
